const textStyles = {
  h1: {
    fontSize: { mobile: '32px', tablet: '40px', laptop: '75px' },
    fontStyle: 'italic',
    fontWeight: 800,
    lineHeight: '110%',
    letterSpacing: { mobile: '-0.5%', tablet: '-1%' },
  },
  h2: {
    fontSize: { mobile: '32px', tablet: '36px', laptop: '60px' },
    fontStyle: 'italic',
    fontWeight: 900,
    lineHeight: { mobile: '115%', tablet: '110%' },
    letterSpacing: { mobile: '-0.5%', tablet: '-1%' },
  },
  h3: {
    fontSize: { mobile: '20px', tablet: '28px', laptop: '32px' },
    fontWeight: 700,
    lineHeight: '140%',
    letterSpacing: '0%',
  },
  h4: {
    fontSize: { mobile: '24px', tablet: '28px', laptop: '38px' },
    fontStyle: 'italic',
    fontWeight: '900',
    lineHeight: { mobile: '125%', tablet: '120%', laptop: '110%' },
    letterSpacing: { mobile: '-0.5%', tablet: '-1%', laptop: '0%' },
  },
  h5: {
    fontSize: { mobile: '18px', tablet: '24px', laptop: '38px' },
    fontStyle: 'italic',
    fontWeight: '700',
    lineHeight: { mobile: '115%', tablet: '120%', laptop: '110%' },
    letterSpacing: { mobile: '-0.5%', tablet: '-1%', laptop: '0%' },
  },
  b1: {
    fontSize: { mobile: '18px', tablet: '20px', laptop: '30px' },
    fontStyle: 'italic',
    fontWeight: 700,
    lineHeight: { mobile: '140%', tablet: '130%' },
    letterSpacing: '0%',
  },
  b2: {
    fontSize: { mobile: '16px', tablet: '18px', laptop: '24px' },
    fontWeight: 500,
    lineHeight: '140%',
    letterSpacing: '0%',
  },
  b3: {
    fontSize: { mobile: '16px', laptop: '18px' },
    fontWeight: 500,
    lineHeight: '140%',
    letterSpacing: '0%',
  },
  b4: {
    fontSize: { mobile: '14px', tablet: '16px' },
    fontWeight: 400,
    lineHeight: '140%',
    letterSpacing: '0%',
  },

  button: {
    fontSize: { mobile: '16px', laptop: '20px' },
    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: '0',
  },
};

export default textStyles;
